const { SplitFactory } = require('@splitsoftware/splitio');
const configurationManager = require('../config/configurationManager');
const stateManager = require('../state/stateManager');

let factory = null;

function initializeFactory()
{
    if (!factory)
    {
        const config = configurationManager.getAppConfig();
        const propertyId = stateManager.getStore().getState().propertyId;

        if (!config.rmsFrontendSplitIoApiKey) 
        {
            console.warn('Split.io API key not configured');
        }

        if (!propertyId) 
        {
            console.warn('Property ID not available for Split.io initialization');
        }

        factory = SplitFactory({
            core: {
                authorizationKey: config.rmsFrontendSplitIoApiKey || '',
                key: propertyId || 'anonymous',
            },
        });
    }

    return factory;
}

module.exports.getSplitClient = async function()
{
    if (!factory)
    {
        factory = initializeFactory();
    }

    const client = factory.client();
    await client.whenReady();
    return client;
};
